import {
  type RouteLocationNormalized,
  type RouteLocationRaw,
} from 'vue-router';
import { PATH_DICTIONARY, authService } from '~/domains/auth';

export const sessionCheckGuard = async (
  to: RouteLocationNormalized,
): Promise<RouteLocationRaw | undefined> => {
  const isActualSession = await authService.ping();

  if (isActualSession !== 'OK' && to.meta.layout !== 'auth') {
    return {
      path: PATH_DICTIONARY.login,
      query: to.query,
    };
  }
};
